import React from "react";

export type PageTab = {
  key: string;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
  hint?: string;
  badge?: React.ReactNode;
};

export function PageTabs({
  tabs, value, onChange,
}: {
  tabs: PageTab[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div className="border-b border-slate-200">
      <div className="flex gap-1 overflow-x-auto">
        {tabs.map((t) => {
          const active = value === t.key;
          const Icon = t.icon;
          return (
            <button
              key={t.key}
              onClick={() => onChange(t.key)}
              className={[
                "px-3.5 pb-3 pt-1 -mb-px border-b-2 inline-flex items-start gap-2 text-left transition whitespace-nowrap",
                active
                  ? "border-el-500 text-slate-900"
                  : "border-transparent text-slate-500 hover:text-slate-700",
              ].join(" ")}
            >
              {Icon && (
                <Icon className={`h-4 w-4 mt-0.5 ${active ? "text-el-600" : "text-slate-400"}`} />
              )}
              <div className="leading-tight">
                <div className="text-sm font-semibold inline-flex items-center gap-1.5">
                  {t.label}
                  {t.badge}
                </div>
                {t.hint && <div className="text-[0.7rem] text-slate-400">{t.hint}</div>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
